export default __webpack_public_path__ + "static/bathroom-discount-ff19e1d24641d1d26aac403d34eecd53.png";